import {library} from "@fortawesome/fontawesome-svg-core";

// Solid icons
import {
    faStarHalfAlt,
    faStar,
    faTire,
    faCheckCircle,
    faAngleLeft,
    faAngleRight,
    faGasPump,
    faCloudShowers,
    faVolume,
    faHeart,
    faPlus,
    faMinus,
    faCircleInfo,
    faCircleXmark,
    faSunBright,
    faArrowUp,
    faArrowDown
} from "@fortawesome/pro-solid-svg-icons";

// Regular icons
import {
    faSearch,
    faBars,
    faStar as faStarRegular,
    faTimes,
    faCheck
} from "@fortawesome/pro-regular-svg-icons";

// Light icons
import {faPencil, faTire as faThinTire} from "@fortawesome/pro-light-svg-icons";

// Dutone icons
import {faStarHalf as faStarHalfDuotone} from "@fortawesome/pro-duotone-svg-icons";

// Thin icons
import {faCarSide, faSpinnerThird} from "@fortawesome/pro-thin-svg-icons";

// Brand icons
import {faInstagram, faYoutube, faFacebookF} from "@fortawesome/free-brands-svg-icons";

library.add(
    faSearch,
    faBars,
    faStarHalfAlt,
    faStar,
    faStarRegular,
    faTire,
    faCheckCircle,
    faStarHalfDuotone,
    faTimes,
    faAngleLeft,
    faAngleRight,
    faGasPump,
    faCloudShowers,
    faVolume,
    faCheck,
    faPencil,
    faHeart,
    faPlus,
    faMinus,
    faCarSide,
    faSpinnerThird,
    faThinTire,
    faCircleInfo,
    faInstagram,
    faYoutube,
    faFacebookF,
    faCircleXmark,
    faSunBright,
    faArrowDown,
    faArrowUp
);
